import React, { useState, useEffect } from "react";
import axios from "axios";

const SignUp = () => {
  const [accountType, setAccountType] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [clubName, setClubName] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // "success" or "error"
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    // Reset message and message type when account type changes
    setMessage("");
    setMessageType("");
  }, [accountType]);

  const handleSignUp = async (e) => {
    e.preventDefault();

    // Validate required fields
    if (!username || !email || !password) {
      setMessage("Please fill in all required fields");
      setMessageType("error");
      return;
    }

    // Validate username and clubName to ensure they contain no spaces
    if (/\s/.test(username)) {
      setMessage("Username cannot contain spaces");
      setMessageType("error");
      return;
    }

    if (accountType === "clubOwner") {
      if (!clubName) {
        setMessage("Please enter your Club Name");
        setMessageType("error");
        return;
      }
      if (/\s/.test(clubName)) {
        setMessage("Club Name cannot contain spaces");
        setMessageType("error");
        return;
      }
    }

    try {
      let endpoint;
      let data;

      switch (accountType) {
        case "clubOwner":
          endpoint = `${BACKEND_URL}/admin/intemptofclubownercreation`;
          data = { name: username, email, password, clubName };
          break;
        case "eventOrganiser":
          endpoint = `${BACKEND_URL}/admin/createAdmin`;
          data = { name: username, email, password };
          break;
        default:
          return;
      }

      const response = await axios.post(endpoint, data);
      setMessage(response.data.message);
      setMessageType("success");
    } catch (error) {
      console.log("ADMIN : ", error.response);
      setMessage(error.response?.data?.message || "Error creating account");
      setMessageType("error");
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const renderForm = () => {
    return (
      <>
        {(accountType === "eventOrganiser" || accountType === "clubOwner") && (
          <form onSubmit={handleSignUp} className="sign-up-form">
            <h2 className="title">
              {accountType === "clubOwner"
                ? "Sign up as Club Owner"
                : "Sign up as Event Organiser/Team Manager-Leader"}
            </h2>
            <div className="input-field">
              <i className="fas fa-user"></i>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) =>
                  setUsername(e.target.value.replace(/\s+/g, ""))
                }
              />
            </div>
            <div className="input-field">
              <i className="fas fa-envelope"></i>
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value.replace(/\s+/g, ""))}
              />
            </div>
            {accountType === "clubOwner" && (
              <div className="input-field">
                <i className="fas fa-user"></i>
                <input
                  type="text"
                  placeholder="Club Name"
                  value={clubName}
                  onChange={(e) => setClubName(e.target.value)}
                />
              </div>
            )}
            <div className="input-field">
              <i className="fas fa-lock"></i>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) =>
                  setPassword(e.target.value.replace(/\s+/g, ""))
                }
              />
              <i
                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"} eye-icon`}
                onClick={togglePasswordVisibility}
              ></i>
            </div>
            {message && (
              <p
                className={
                  messageType === "success"
                    ? "message-success"
                    : "message-error"
                }
              >
                {message}
              </p>
            )}
            <input type="submit" className="btn" value="Sign up" />
          </form>
        )}
        {accountType === "rppPromoteur" && (
          <form className="sign-up-form">
            <div className="info-box">
              <h2 className="title">Become an RPP-PROMOTEUR</h2>
              <p>
                To become a promoter or RPP, you will need to create a PATT
                account through the app and subsequently ask team managers to
                add you to their team using your PATT usernames and your unique
                name to define you. Intall PATT and create a non-guest account{" "}
                <a href="https://mzj0x.app.link/nAUYF8EuFHb">Click here</a>
              </p>
            </div>
            {message && (
              <p
                className={
                  messageType === "success"
                    ? "message-success"
                    : "message-error"
                }
              >
                {message}
              </p>
            )}
          </form>
        )}
      </>
    );
  };

  return (
    <div className="account-creation">
      <h1 style={{ color: "white" }}>
        How do you want to create your account?
      </h1>
      <div className="options">
        <div
          className={`option ${accountType === "clubOwner" ? "selected" : ""}`}
          onClick={() => setAccountType("clubOwner")}
        >
          <i className="fas fa-users-cog"></i>
          <span>Club Owner</span>
        </div>
        <div
          className={`option ${accountType === "eventOrganiser" ? "selected" : ""}`}
          onClick={() => setAccountType("eventOrganiser")}
        >
          <i className="fas fa-calendar-alt"></i>
          <span>Event Organiser/Team Manager-Leader</span>
        </div>
        <div
          className={`option ${accountType === "rppPromoteur" ? "selected" : ""}`}
          onClick={() => setAccountType("rppPromoteur")}
        >
          <i className="fas fa-bullhorn"></i>
          <span>RPP-PROMOTEUR</span>
        </div>
      </div>
      {renderForm()}
    </div>
  );
};

export default SignUp;
